import { Component, EventEmitter, Input, OnInit, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment-timezone';
import { takeUntil } from 'rxjs/operators';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { DriversService } from '../../component/drivers/drivers-service/drivers-service';
import { BreakModalService } from './break-modal-service/break-modal.service';
import { sweetAlert } from 'src/app/utils/swal';
@Component({
  selector: 'app-break-modal',
  templateUrl: './break-modal.component.html',
  styleUrls: ['./break-modal.component.css']
})
export class BreakModalComponent implements OnInit {
  breakForm: FormGroup
  timeZone;
  user
  submitted = false;
  todayDate = moment();
  @Input() data;
  @Output() closeModal = new EventEmitter<any>()
  @Output() payload = new EventEmitter<any>()
  constructor(
    private breakService : BreakModalService,
    private fb: FormBuilder,
    private sharedDataService: SharedDataService,
    ) { }

  ngOnInit() {
    this.breakForm = this.fb.group({
      displayName:['Rest Break',Validators.required],
      preScheduleTime: [moment()],
      scheduleTime: [moment().toISOString(), Validators.required],
      preAppointmentTime: [moment().add(15,'minutes')],
      appointmentTime: [moment().add(15,'minutes').toISOString(), Validators.required],
    });

    this.getUser();
  }

  ngOnChanges(change:SimpleChanges) {
    if (change.data && change.data.currentValue && change.data.currentValue.break) {
    }
  }

  getMinDate() {
    return moment(this.todayDate).startOf('day');
  }


  getMaxDate() {
    return moment(this.todayDate).endOf('day');
  }

  getStartMinDate() {
    return moment(this.breakForm.value.preScheduleTime);
  }

  getUser() {
    this.sharedDataService.getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.user = data;
          this.timeZone = this.user.timeZone;
          this.setPreData();
        }
      });
  }

  setPreData() {

    const now = moment().tz(this.timeZone);
    this.todayDate = now;
    if (this.data) {
      this.todayDate = moment.tz(this.data.date, this.timeZone).set({
        hour: now.hour(),
        minute: now.minute(),
        second: 0,
        millisecond: 0
      });
    }

    this.breakForm.patchValue({
      preScheduleTime: this.todayDate,
      scheduleTime: this.todayDate,
      preAppointmentTime:  moment(this.todayDate).add(15,'minutes'),
      appointmentTime: moment(this.todayDate).add(15,'minutes').toISOString()
    });


// update
    if (this.data && this.data.break) {
      this.breakForm.patchValue({
        ...this.data.break,
        preScheduleTime: moment(this.data.break.scheduleTime).tz(this.timeZone),
        preAppointmentTime: moment(this.data.break.appointmentTime).tz(this.timeZone)
      });
    }
  }

  onCreate() {
    this.submitted = true;
    if(this.breakForm.invalid){
      return;
    }
    const payload = this.breakForm.value;
    delete this.breakForm.value.preScheduleTime;
    delete this.breakForm.value.preAppointmentTime;

    if (this.data && this.data.break) {
      payload._id = this.data.break._id
    }

    payload.driver = this.data.driver._id;

    this.payload.emit(payload);
  }

  onScheduleTimeChange(evt) {
    this.breakForm.patchValue({
      scheduleTime: moment(evt).tz(this.timeZone, true).toISOString(),
    });

    if (!this.data.break) {

      if (this.breakForm.value.displayName === "Rest Break") {
        this.breakForm.patchValue({
          preAppointmentTime: moment(evt).add(15, 'minutes')
        });
      } else {
        this.breakForm.patchValue({
          preAppointmentTime: moment(evt).add(30, 'minutes')
        });
      }

    }
  }

  onAppointmentTimeChange(evt) {
    this.breakForm.patchValue({
      appointmentTime: moment(evt).tz(this.timeZone, true).toISOString(),
    });
  }

  onCloseModal() {
    this.closeModal.emit(false)
  }

  get form() {
    return this.breakForm.controls;
  }

  ngOnDestroy(): void {
  }

}
